import { computed, onMounted, reactive, onBeforeUnmount } from 'vue';
import store from '@/store/';

export function useApiLog() {
  let lastActivePage = 1;

  const page = reactive({
    isLoading: false,
    output: false
  });

  const meta = computed(() => store.state.ApiLog.meta);
  const apiLog = computed(() => store.state.ApiLog.apiLog);

  const tenantOptions = computed(() => {
    const tenants = store.state.ApiLog.tenants;
    if (!tenants) return [];
    return tenants.filter(tenant => tenant).map(tenant => ({
      value: tenant,
      text: tenant.replace('tenant_', '')
    }));
  });

  function load_state() {
    page.isLoading = true;
    store.dispatch('ApiLog/read')
      .catch(err => console.error(err))
      .finally(() => {
        page.isLoading = false;
        page.output = true;
      });
  }

  function navPage(pageNumber) {
    const updatedMeta = { ...meta.value, page: pageNumber };
    store.commit('ApiLog/switch_page', { meta: updatedMeta });
    load_state();
  }

  function search(searchBy) {
    const { selected, criteria } = searchBy;
    if (selected && criteria) {
      page.isLoading = true;
      let search = {};
      search[selected] = criteria;
      store.commit('ApiLog/set_search', { search });
      store.dispatch('ApiLog/read').finally(() => {
        page.isLoading = false;
      });
    }
  }

  function clearSearch() {
    page.isLoading = true;
    const updatedMeta = { ...meta.value, page: lastActivePage };
    store.commit('ApiLog/switch_page', { meta: updatedMeta });
    store.commit('ApiLog/clear_search');
    store.dispatch('ApiLog/read').finally(() => {
      page.isLoading = false;
    });
  }

  onMounted(() => {
    store.commit('ApiLog/reset_meta');
    load_state();
  });

  onBeforeUnmount(() => {
    const updatedMeta = { ...meta.value, page: lastActivePage };
    store.commit('ApiLog/switch_page', { meta: updatedMeta });
    store.commit('ApiLog/clear_search');
    store.dispatch('ApiLog/read').then(() => {});
  });

  return {
    page,
    meta,
    apiLog,
    tenantOptions,
    load_state,
    navPage,
    search,
    clearSearch
  };
}